export type WeakPasswordReason = "triple" | "sequence" | "alternate" | null;

const TRIPLE_REGEX = /(\d)\1\1/;
const ALTERNATE_REGEX = /(\d)(\d)\1\2/;

export function getWeakPasswordReason(password: string): WeakPasswordReason {
  if (!password) {
    return null;
  }

  if (TRIPLE_REGEX.test(password)) {
    return "triple";
  }

  for (let i = 0; i + 2 < password.length; i++) {
    const a = Number(password[i]);
    const b = Number(password[i + 1]);
    const c = Number(password[i + 2]);

    if (Number.isNaN(a) || Number.isNaN(b) || Number.isNaN(c)) {
      continue;
    }

    if (b === a + 1 && c === b + 1) {
      return "sequence";
    }

    if (b === a - 1 && c === b - 1) {
      return "sequence";
    }
  }

  if (ALTERNATE_REGEX.test(password)) {
    return "alternate";
  }

  return null;
}

const REASON_HINTS: Record<Exclude<WeakPasswordReason, null>, string> = {
  triple: "Слишком простой пароль: нельзя три одинаковые цифры подряд",
  sequence:
    "Слишком простой пароль: нельзя последовательность цифр подряд, например 123 или 987",
  alternate:
    "Слишком простой пароль: нельзя чередование двух цифр, например 4545",
};

export function getWeakPasswordHint(password: string): string | null {
  const reason = getWeakPasswordReason(password);
  return reason ? REASON_HINTS[reason] : null;
}
